export const fmtShort = (n) => {
  n = Number(n) || 0;
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1) + "M";
  if (n >= 1_000) return (n / 1_000).toFixed(n % 1_000 === 0 ? 0 : 1) + "K";
  return String(n);
};

export const fmtFull = (n) => (Number(n) || 0).toLocaleString("en-US");

// Money is stored as integer cents. null means genuinely unknown -> "Unreconciled" (never $0).
export const fmtMoney = (cents) => {
  if (cents == null) return "Unreconciled";
  return (cents / 100).toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 });
};
export const fmtMoney0 = (cents) => {
  if (cents == null) return "—";
  return (cents / 100).toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
};

// Parse date-only strings (YYYY-MM-DD) as LOCAL midnight so toLocaleDateString never
// shifts them a day back in timezones behind UTC (e.g. Sep 27 -> Sep 26 in LA).
// Full ISO datetimes (with a time/offset) are true instants and parse normally.
const parseLocalDate = (iso) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso).trim());
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  return new Date(iso);
};

export const timeAgo = (iso) => {
  if (!iso) return "—";
  const then = new Date(iso).getTime();
  const diff = Date.now() - then;
  const mins = Math.round(diff / 60000);
  if (Math.abs(mins) < 60) return `${Math.max(1, Math.abs(mins))} min${mins === 1 ? "" : "s"} ago`;
  const hrs = Math.round(mins / 60);
  if (Math.abs(hrs) < 24) return `${hrs} hour${hrs === 1 ? "" : "s"} ago`;
  const days = Math.round(hrs / 24);
  if (Math.abs(days) < 30) return `${days} day${days === 1 ? "" : "s"} ago`;
  return parseLocalDate(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  return parseLocalDate(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};
